module.exports = __webpack_public_path__ + "img/OT934.0ffb67b.webp";